var Ajv = require('ajv/lib/ajv');
var JsonEditorModalController = function($scope, $uibModalInstance, editor_config, model, schema) {
    $scope.name = editor_config.name || 'Json Editor';
    $scope.mode = editor_config.mode || 'tree';
    $scope.title = editor_config.title || 'Edit';
    $scope.model = model;
    $scope.schema = schema;
    $scope.can_save = false;
    $scope.can_not_save_reason = 'No changes';

    $scope.avj = Ajv({allErrors: true, verbose: true});
    $scope.validator = $scope.avj.compile($scope.schema || {});
    $scope.jsoneditor_options = angular.extend(
        editor_config.jsoneditor_options || {},
        {
            name: $scope.name,
            mode: $scope.mode,
            schema: $scope.schema || {},
            onChange: function (data, error) {
                $scope.can_save = $scope.validator($scope.model.model);
                $scope.can_not_save_reason = $scope.can_save ? 'Ok' : 'Data is not valid'
            },
            ajv: $scope.avj
        }
    );

    $scope.save = function () {
        $uibModalInstance.close($scope.model);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss($scope.model);
    };
};

JsonEditorModalController.$injector = ['$scope', '$uibModalInstance', 'editor_config', 'model', 'schema'];

var JsonEditorModalFactory = function ($uibModal) {
    var m = {};

    m.open = function (editor_config_promise, model_promise, schema_promise, modal_config) {
        var new_modal_config = angular.extend(
            {
                animation: true,
                keyboard: false,
                backdrop: 'static',
                windowClass: 'amt-modal-max-width',
                templateUrl: 'amt.jsoneditor/modal.html'
            },
            modal_config || {},
            {
                resolve: {
                    editor_config: function () {
                        return editor_config_promise
                    },
                    model: function () {
                        return model_promise;
                    },
                    schema: function () {
                        return schema_promise
                    }
                },
                controller: JsonEditorModalController
            }
        );
        var model_instance = $uibModal.open(new_modal_config);
        return model_instance.result
    };
    return m;
};

export default function (module) {
    module.factory('JsonEditorModal', ['$uibModal', JsonEditorModalFactory])
};
